import React from "react";
import "./FeaturesSection.css";

const features = [
  {
    icon: "🍽️",
    title: "GOURMET CULINARY EXPERIENCE",
    desc: "Savor a variety of cuisines – from local Maharashtrian delights to Continental favorites – crafted to delight your taste buds at every meal.",
  },
  {
    icon: "🔒",
    title: "PRIVACY & SERENITY",
    desc: "Enjoy complete peace in our secluded rooms and private spaces, where the only sounds are nature’s whispers and the gentle mountain breeze.",
  },
  {
    icon: "📍",
    title: "SCENIC HILLTOP LOCATION",
    desc: "Perched in the heart of New Mahabaleshwar, Jaltaara offers panoramic views of lush valleys, rolling hills, and pristine greenery.",
  },
  {
    icon: "📅",
    title: "EASY ONLINE BOOKINGS",
    desc: "Plan your stay effortlessly with our simple online reservation system. Choose your dates and secure your luxury retreat in minutes.",
  },
  {
    icon: "🔔",
    title: "DEDICATED HOSPITALITY",
    desc: "Our attentive staff is always ready to assist discreetly, ensuring a seamless, comfortable, and memorable stay.",
  },
  {
    icon: "🛏️",
    title: "IMMERSIVE NATURE RETREAT",
    desc: "Reconnect with nature from the comfort of your room. Wake up to misty mornings, fresh air, and scenic surroundings exclusive to Jaltaara.",
  },
];

function FeaturesSection() {
  return (
    <section className="featuresSection">
      <div className="container">
        <div className="row">
          {features.map((item, index) => (
            <div className="col-md-4 featureBox" key={index}>
              <div className="featureIcon">{item.icon}</div>
              <h4 className="featureTitle">{item.title}</h4>
              <p className="featureDesc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
